(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oudie-desktop-nav"] && !Shopify.designMode) return;
  try {
    class OudieDesktopNav extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const opened = this.querySelector('details[open]');
        if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { if (!this.contains(document.activeElement)) this.close(); });
      }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      this.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => { if (detail.open) this.close(detail); }, options);
      });
      window.addEventListener('resize', () => { if (window.innerWidth < 990) this.close(); }, options);
    }
    close(except) { this.querySelectorAll('details[open]').forEach((detail) => { if (detail !== except) detail.open = false; }); }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('oudie-desktop-nav')) customElements.define('oudie-desktop-nav', OudieDesktopNav);
  } catch(e) { console.error(e); }
})();

})();
